/**
 * @generated SignedSource<<92c638a07932794c52a1833b72a30e7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FiatTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type FiatTransactionFeeInput = {
  amount: string;
  fiatId?: string | null | undefined;
  type: FiatTransactionType;
};
export type FiatTransactionFeeViewQuery$variables = {
  input: FiatTransactionFeeInput;
};
export type FiatTransactionFeeViewQuery$data = {
  readonly fiatTransactionFee: PrecisionFloat | null | undefined;
};
export type FiatTransactionFeeViewQuery = {
  response: FiatTransactionFeeViewQuery$data;
  variables: FiatTransactionFeeViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "fiatTransactionFee",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiatTransactionFeeViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiatTransactionFeeViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5bcb83b0b7d7efbc7b6392d8647090a",
    "id": null,
    "metadata": {},
    "name": "FiatTransactionFeeViewQuery",
    "operationKind": "query",
    "text": "query FiatTransactionFeeViewQuery(\n  $input: FiatTransactionFeeInput!\n) {\n  fiatTransactionFee(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "1d47f0880b4933e714e42b17b3dd4415";

export default node;
